export default __webpack_public_path__ + "images/header-bg.png";